import Find from "./Find";
import List from "./List";
import Import from "./Import";

const Index = () => {
    return (
        <>
            <ul className="nav nav-pills mb-3 mt-4" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#find" type="button" role="tab" aria-controls="find" aria-selected="true">جستجو فرزندان</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#list" type="button" role="tab" aria-controls="list" aria-selected="true">لیست فرزندان ثبت شده</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#import" type="button" role="tab" aria-controls="import" aria-selected="true">درون ریزی لیست فرزندان</button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="find" role="tabpanel" tabindex="0">
                    <Find />
                </div>
                <div className="tab-pane fade" id="list" role="tabpanel" tabindex="0">
                    <List />
                </div>
                <div className="tab-pane fade" id="import" role="tabpanel" tabindex="0">
                    <Import />
                </div>
            </div>
        </>
    )
}

export default Index;